import { RowingTwoTone } from '@material-ui/icons';
import React from 'react';
import '../CustomTabs/style.less';

class CustomTabs extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      selectedTab: this.props.currentSelectedTab,
      childComponent: (this.props.tabsList || []).find(x => x.id === this.props.currentSelectedTab).childComponent || <></>,
      currentSelectedTab: this.props.currentSelectedTab
    };
  }

  handleClick = (row) => {
    console.log(row);
    this.setState({ childComponent: '' }, () => this.setState({ selectedTab: row.id, childComponent: row.childComponent }));
  }

  render () {
    const { selectedTab, childComponent } = this.state;
    const list = this.props.tabsList;
    return (
      <>
      <div className="col-sm-12 col-lg-12 tabs" >
        {(list || []).map((row, index) => (
          <div className={'tab-capsule ' + (selectedTab === row.id ? 'selected' : '')} key={index + 'list'} onClick={() => this.handleClick(row)}>
            {row.name}
          </div>
        ))}
        </div>
        <div className="col-xs-12">
          {childComponent}
        </div>
        </>
    );
  }
}

export default CustomTabs;
